import { useEffect, useState } from 'react'

export function LoadingMessage() {
  const [isTakingTooLong, setIsTakingTooLong] = useState(false)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsTakingTooLong(true)
    }, 6000)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <div className='flex h-screen w-full flex-col items-center justify-center bg-brand-gray-50 text-sm text-brand-gray-400'>
      {isTakingTooLong ? 'Still working on it... Please wait... ' : 'Loading...'}
    </div>
  )
}
